export default __webpack_public_path__ + "static/media/logo.cdf96f84.png";